import { ThreadChat } from "components/Thread/ThreadChat";
import { UnstyledChannel } from "components/UnstyledChannel/UnstyledChannel";
import { useGetMessage } from "hooks/useGetMessage";
import { useMemo } from "react";
import { MessageResponse } from "stream-chat";
import { DefaultStreamChatGenerics, useChatContext } from "stream-chat-react";

export const FinancialReviewAIChat = ({
  channelId,
  parentMessageId,
  showChannel,
  setShowChannel,
}: {
  channelId: string;
  parentMessageId: string;
  showChannel: boolean;
  setShowChannel: (show: boolean) => void;
}) => {
  const messageToQuote = useGetMessage(parentMessageId!);
  const { client } = useChatContext();

  const channel = useMemo(() => {
    return client.channel("messaging", channelId);
  }, [channelId]);

  const stableThreadMessage = useMemo(() => {
    if (!messageToQuote?.id) return null;
    return {
      id: messageToQuote.id,
      text: messageToQuote.text,
      user: messageToQuote.user,
      created_at: messageToQuote.created_at,
      reply_count: messageToQuote.reply_count,
    };
  }, [
    messageToQuote?.id,
    messageToQuote?.text,
    messageToQuote?.user?.id,
    messageToQuote?.created_at,
    messageToQuote?.reply_count,
  ]);

  return (
    <UnstyledChannel channel={channel} fullheight={true}>
      <ThreadChat
        threadMessage={
          stableThreadMessage as MessageResponse<DefaultStreamChatGenerics>
        }
        open={showChannel}
        onClose={() => setShowChannel(false)}
        headerDescription="Your AI assistant for all updates"
        isSummaryThread={true}
      />
    </UnstyledChannel>
  );
};
